import { createContext, type Context } from 'react';
import noop from 'lodash/noop';

export type IssuePreviewViewModeActions = Readonly<{
	setDetailViewAsModal: (willSave?: boolean) => void;
	setDetailViewAsSidebar: (willSave?: boolean) => void;
}>;

// Package-internal context for the preview-mode setters. External consumers must subscribe through
// useIssuePreviewViewModeActions(); this context is not part of the public API.
export const viewModeActionsContext: Context<IssuePreviewViewModeActions> =
	createContext<IssuePreviewViewModeActions>({
		setDetailViewAsModal: noop,
		setDetailViewAsSidebar: noop,
	});
